<template>
  <f-button
    class="c-button-add-to-cart"
    :disabled="isProcessing"
    :hex-background="hexBackground"
    html-tag="button"
    :size="size"
    @button-clicked.stop.prevent="addToCart"
  >
    <i class="c-button-add-to-cart__icon icon-cart-add"></i>
    {{ buttonLabel }}
  </f-button>
</template>

<script>
import { isDesktop } from '~/js/templates/index/helpers'
import FButton from '~/js/components/button'
import { addToCart } from '~/js/helpers/addToCart'
import { pushCartAddedEvent } from '~/js/gtm'
const REGEX_HEX = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/

export class ItemAddToCart {
  constructor(item) {
    this.handle = item.handle
    this.id = item.variantId
    this.sku = item.sku
    this.variantId = item.variantId || ''
    this.position = item.position
    this.quantity = item.quantity || 1
    this.productTitlePrefix = `${item.text1 || ''}${item.text2 || ''}`
    this.productTitle = item.title
    this.image = item.image || item.productImage
  }
}

export default {
  name: 'ComponentButtonAddToCart',
  props: {
    hexBackground: {
      type: String,
      default: undefined,
      validator: (value) => {
        return !value || REGEX_HEX.test(value)
      },
    },
    items: { type: Array, default: () => [] },
    text: { type: String, default: '' },
  },
  components: {
    FButton,
  },
  data() {
    return {
      isProcessing: false,
    }
  },
  computed: {
    buttonLabel() {
      return this.text || (this.size === 'small' ? '追加' : 'カートに追加する')
    },
    size() {
      return (!window.location.href.includes('/account?view=productlist') &&
        !window.location.href.includes('/account?view=favorites') &&
        !window.location.href.includes('/blogs/coordinate') &&
        !isDesktop()) ||
        this.$root.$options.name === 'SnippetsHeader'
        ? 'small'
        : undefined
    },
  },
  methods: {
    async addToCart() {
      this.isProcessing = true
      try {
        const { itemsAdded, itemsAddFailed } = await addToCart(this.items)
        if (!itemsAdded)
          throw new Error('カートに追加できる商品がありませんでした')

        window.dispatchEvent(
          new CustomEvent('cart-added', {
            detail: { items: itemsAdded, itemsAddFailed },
          })
        )
        pushCartAddedEvent({ items: itemsAdded })
      } catch (e) {
        const message = e.message || '在庫切れです。'
        alert(message)
        console.error(e)
      }
      this.isProcessing = false
    },
  },
}
</script>

<style lang="scss" scoped>
.c-button-add-to-cart {
  &__icon {
    font-size: 16px;
    line-height: 1;
    margin-right: 5px;
  }
}
</style>
